import { existsSync } from "fs";
import { dirname, relative, resolve, sep } from "path";
import { prefixRegex } from "rolldown/filter";
import { normalizePath } from "vite";
import { processImageMeta } from "../../image/getImageData";
var IMAGEDATA_SUFFIX = "?imagedata";
var VIRTUAL_PREFIX = "\0imagedata:";
var IMAGEDATA_SUFFIX_RE = /\?imagedata$/;
function imageDataPlugin() {
  var publicDir;
  var root;
  function getSrcPath(filePath) {
    return filePath.startsWith(publicDir) ? "/" + normalizePath(relative(publicDir, filePath)) : "/" + normalizePath(relative(root, filePath));
  }
  function isPathWithinBounds(filePath, allowedDir) {
    var resolved = resolve(filePath);
    var allowed = resolve(allowedDir);
    return resolved.startsWith(allowed + sep) || resolved === allowed;
  }
  function createImageDataExport(src) {
    var width = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, height = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, blurDataURL = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    return `export default ${JSON.stringify({
      src,
      width,
      height,
      blurDataURL
    })}`;
  }
  return {
    name: "one:imagedata",
    enforce: "pre",
    configResolved(resolvedConfig) {
      publicDir = resolvedConfig.publicDir;
      root = resolvedConfig.root;
    },
    resolveId: {
      filter: {
        id: IMAGEDATA_SUFFIX_RE
      },
      async handler(id, importer) {
        var cleanId = id.slice(0, -IMAGEDATA_SUFFIX.length);
        var filePath;
        var allowedDir;
        if (cleanId.startsWith("/")) {
          filePath = resolve(publicDir, cleanId.slice(1));
          allowedDir = publicDir;
        } else if (importer) {
          filePath = resolve(dirname(importer.replace(VIRTUAL_PREFIX, "")), cleanId);
          allowedDir = root;
        } else {
          filePath = resolve(root, cleanId);
          allowedDir = root;
        }
        if (!isPathWithinBounds(filePath, allowedDir)) {
          console.warn(`[one] ?imagedata: Path traversal blocked: ${cleanId}`);
          return null;
        }
        if (!existsSync(filePath)) {
          console.warn(`[one] ?imagedata: File not found: ${filePath}`);
          return null;
        }
        return VIRTUAL_PREFIX + filePath;
      }
    },
    load: {
      filter: {
        id: prefixRegex(VIRTUAL_PREFIX)
      },
      async handler(id) {
        var filePath = id.slice(VIRTUAL_PREFIX.length);
        var src = getSrcPath(filePath);
        this.addWatchFile(filePath);
        var meta = await processImageMeta(filePath);
        if (!meta) {
          return createImageDataExport(src);
        }
        return createImageDataExport(src, meta.width, meta.height, meta.blurDataURL);
      }
    }
  };
}
export {
  imageDataPlugin
};
//# sourceMappingURL=imageDataPlugin.js.map
